<template>
  <div>

    <b-modal
      v-model="localShow"
      title="Fast Reply"
      @close="$emit('close-event')"
    >
    <b-container fluid>

 <b-form-group label="Cutter">
      <b-form-radio-group
        id="radio-group-cutter"
        v-model="selection"
        name="radio-sub-component"
        stacked
      >
        <b-form-radio value="EingeladeneCutter">Freitext an alle Eingeladenen</b-form-radio>
        <b-form-radio value="ZugesagteCutter">Freitext an alle die sich beworben habe</b-form-radio>
        <b-form-radio value="KeineReaktionCutter">Reminder an alle die sich nicht beworben haben</b-form-radio>
        <b-form-radio value="GewählterCutter">Reminder, die Rechnung hochzuladen</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

 <b-form-group label="Kunde">
      <b-form-radio-group
        id="radio-group-kunde"
        v-model="selection"
        name="radio-sub-component"
      >
        <!-- alles was mit FastReply anfängt geht an den Kunden -->
        <b-form-radio value="FastReplyBewerbungen">Cutter haben sich beworben - wir prüfen</b-form-radio>
        <b-form-radio value="FastReplyKeine">Es konnte kein Cutter gefunden werden</b-form-radio>
        <b-form-radio value="FastReplyFreitext">Freitext an Kunde</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

 <b-form-group >
       <b-form-checkbox class="d-none" v-model="selectedFreiText"></b-form-checkbox>Freitext
       <b-textarea v-model="message" :disabled="!selectedFreiText" ></b-textarea>
    </b-form-group>

      </b-container>

      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="submit()"
          >
            Ausführen
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import afunc from '@/functions'
import api from '@/api/workflow'
import utils from '@/utilities'

export default {
  props: ['show', 'auftrag'],
  watch: {
    show: function (nShow) {
      this.localShow = nShow
    },
    selection: function (val) {
      switch (val) {
        case 'EingeladeneCutter':
          this.selectedFreiText = true
          break
        case 'ZugesagteCutter':
          this.selectedFreiText = true
          break
        case 'FastReplyFreitext':
          this.selectedFreiText = true
          break
        default:
          this.selectedFreiText = false
          break
      }
    }
  },
  methods: {
    async submit () {
      this.$emit('close-event')
      var formData = new FormData()
      formData.append('message', this.message)
      formData.append('freitext', this.selectedFreiText)
      formData.append('targets', this.selection)
      let result = await afunc.actionFunc(this.$parent, api, {'type': 'FastReplyDo'}, this.auftrag.id, formData)
      if (result && result['errorMessage']) {
        utils.makeToast(this.$parent, result['errorMessage'], 'danger')
      } else {
        if (result && !result['noMessage']) {
          utils.makeToast(this, 'Erfolgreich ausgeführt!', 'success')
        }
      }
    }
  },
  data () {
    return {
      message: '',
      localShow: false,
      selection: '',
      selectedFreiText: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/main/vue/components/partials/FastReply.vue